import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaysAfterValidatorDirective } from './days-after-validator.directive';
import { DaysBeforeValidatorDirective } from './days-before-validator.directive';
import { EqualValidatorDirective } from './equal-validator.directive';
import { GreaterThanDirective } from './greater-than.validator';

@NgModule({
    imports: [CommonModule],
    declarations: [
        DaysAfterValidatorDirective,
        DaysBeforeValidatorDirective,
        EqualValidatorDirective,
        GreaterThanDirective,
    ],
    exports: [
        DaysAfterValidatorDirective,
        DaysBeforeValidatorDirective,
        EqualValidatorDirective,
        GreaterThanDirective,
    ],
})
export class ComparisonValidatorsModule
{
}
